module.exports = __webpack_public_path__ + "images/video-failed.7a7e51c1b487b2aa7aabb3fc1dd49ea6.png";